export const API_PATH = '/api' as const;

export const API_BLOG = `${API_PATH}/blog` as const;
export const API_BLOG_ALL = `${API_PATH}/blog/all` as const;
export const API_BLOG_POST = `${API_PATH}/blog/post` as const;
export const API_BLOG_CATEGORIES = `${API_PATH}/blog/categories` as const;

export const PAGE_BLOG = '/wedding-ideas-blog' as const;
export const PAGE_BLOG_POST = '/wedding-ideas-blog/[post]' as const;
